/**
 * React 异常边界
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as logger from '../../util-lib/logger';


export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    placeholder: PropTypes.node.isRequired
  };

  state = {
    hasError: false
  };

  static getDerivedStateFromError(error) {
    return { hasError: !!error };
  }

  // eslint-disable-next-line
  componentDidCatch(error, errorInfo) {
    logger.error(error, { extras: errorInfo });
  }

  render() {
    const { hasError } = this.state;
    const { children, placeholder } = this.props;

    if (hasError) {
      return placeholder;
    }

    return children;
  }
}
